import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type CopilotResultsAccountState from '../store/schema/CopilotResultsAccountState';
import type CopilotResultsStatus from '../store/schema/CopilotResultsStatus';
import getListViewStore from '../store/Store';

function createDefaultCopilotResultsAccountState(): CopilotResultsAccountState {
    return {
        copilotResultsTableViewId: undefined,
        copilotResultsOriginTableViewId: undefined,
        copilotResultsStatus: 0,
        copilotResultsConversationId: undefined,
    };
}

export default function getCopilotResultsAccountState(
    mailboxInfo: MailboxInfo
): CopilotResultsAccountState {
    const store = getListViewStore();
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const existing = store.copilotResultsStateByAccount.get(accountKey);
    if (existing) {
        return existing;
    }
    const newState = createDefaultCopilotResultsAccountState();
    store.copilotResultsStateByAccount.set(accountKey, newState);
    return store.copilotResultsStateByAccount.get(accountKey) ?? newState;
}
